<template>
    <main id="mainCtrl">
        <ValidationObserver ref="actionForm">
            <form  id="actionBtnForm" v-if="clinics.length">
                <div class="promo">
                    <div class="promo__title">
                        <label><input type="checkbox" v-model="M.actionButtonOn" :value="true"><span></span></label><span>Кнопка действия</span>
                    </div>
                    <div class="promo__data">
                        <div class="promo__text">
                            <p>
                                Настройте «Кнопку действия», чтобы получить больше переходов пациентов с нашего сайта.
                            </p>
                            <ol>
                                <li>Выберите название кнопки</li>
                                <li>Укажите ссылку для перехода</li>
                                <li>Получите больше пациентов</li>
                            </ol>

                            <div class="promo__form">
                                <div class="field field-select" :class="{disabled: !M.actionButtonOn}">
                                    <label>
                                        Название клиники
                                    </label>
                                    <div class="field-select__wrap">
                                        <v-select
                                            :disabled="!M.actionButtonOn"
                                            @select="refresh"
                                            v-model="selectedClinicId"
                                            placeholder="Выберите клинику"
                                            :searchable="false"
                                            :options='clinics.map((clinic)=> {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'
                                        >
                                            <template v-slot="{ option }">
                                                <div class="textarea">
                                                    <span>{{ option.text }}</span>
                                                    <div style="height: 8px;"/>
                                                    <small>{{ option.fullAddress }}</small>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="field field-select" :class="{disabled: !M.actionButtonOn}">
                                    <label>
                                        Название кнопки
                                    </label>
                                    <div class="field-select__wrap">
                                        <v-select
                                            :disabled="!M.actionButtonOn"
                                            v-model="M.actionButtonName"
                                            :searchable="false"
                                            :options="[
                                                {value: 'Перейти на сайт', text: 'Перейти на сайт'},
                                                {value: 'Заказать звонок', text: 'Заказать звонок'},
                                                {value: 'Записаться', text: 'Записаться'},
                                                {value: 'Записаться онлайн', text: 'Записаться онлайн'},
                                                {value: 'Написать в Telegram', text: 'Написать в Telegram'},
                                                {value: 'Написать в WhatsApp', text: 'Написать в WhatsApp'},
                                                {value: 'Посмотреть на YouTube', text: 'Посмотреть на YouTube'},
                                                {value: 'Получить скидку', text: 'Получить скидку'},
                                                {value: 'Поучаствовать в акции', text: 'Поучаствовать в акции'},
                                                {value: 'Вызвать врача', text: 'Вызвать врача'},
                                                {value: 'Получить консультацию', text: 'Получить консультацию'},
                                            ]"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="field field-text">
                                    <label>
                                        Ссылка для перехода
                                    </label>
                                    <div class="field-text__wrap">
                                        <vee-input placeholder="site.ru"
                                                   v-model="M.actionButtonHref"
                                                   vid="hrefAction"
                                                   :rules="{required: M.actionButtonOn}"
                                                   :disabled="!M.actionButtonOn"
                                        />
                                        <div v-if="M.actionButtonHref"
                                             class="field-text__wrap_clear"
                                             @click.prevent="M.actionButtonHref = ''">
                                            <img src="/img/clear_12x12.svg" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="promo__actions">
                                    <v-loading-component :disabled="!M.actionButtonOn || !needSave" @click="onUpdate" >
                                        <template slot-scope="{ loadingClass }">
                                            <a class="promo__btn" :disabled="!needSave" :class="[loadingClass]">Сохранить</a>
                                        </template>
                                    </v-loading-component>
                                </div>


                            </div>

                        </div>
                    </div>
                    <div class="promo__clinic">
                        <div class="promo__clinic-title">
                            Предварительный просмотр
                        </div>

                        <div class="clinic">
                            <div class="clinic_profile">
                                <div class="clinic_profile__img">
                                    <img src="" :src="clinic.img ? storagePublicUrl + '/images/clinics/150x150/' + clinic.img : '/_assets/pic_clinic.svg'" alt="">
                                </div>
                            </div>
                            <div class="clinic_info">
                                <div class="clinic_reviews">
                                    <div v-if="clinic.isPatientChoice" class="clinic_reviews__label">
                                        <svg viewBox="0 0 151 23">
                                            <rect x="0.393555" width="150" height="23" rx="4" fill="url(#icn-crown-wide-gradient)"/>
                                            <path d="M13.904 6.89408C14.1811 6.72581 14.3658 6.42052 14.3658 6.07677C14.3658 5.54552 13.9307 5.11523 13.3936 5.11523C12.8564 5.11523 12.4213 5.54552 12.4213 6.07677C12.4213 6.42293 12.6061 6.72581 12.8831 6.89408L11.4904 9.64889C11.2692 10.0864 10.6956 10.2114 10.3092 9.9061L8.14355 8.19216C8.26508 8.0311 8.338 7.83158 8.338 7.61523C8.338 7.08398 7.90293 6.6537 7.36578 6.6537C6.82862 6.6537 6.39355 7.08398 6.39355 7.61523C6.39355 8.14648 6.82862 8.57677 7.36578 8.57677H7.38279L8.49355 14.62C8.62724 15.3508 9.27133 15.8845 10.0248 15.8845H16.7623C17.5133 15.8845 18.1574 15.3532 18.2936 14.62L19.4043 8.57677H19.4213C19.9585 8.57677 20.3936 8.14648 20.3936 7.61523C20.3936 7.08398 19.9585 6.6537 19.4213 6.6537C18.8842 6.6537 18.4491 7.08398 18.4491 7.61523C18.4491 7.83158 18.522 8.0311 18.6436 8.19216L16.4779 9.9061C16.0915 10.2114 15.5179 10.0864 15.2967 9.64889L13.904 6.89408Z" fill="white"/>
                                            <path d="M27.6187 6.71973H30.3735C31.6515 6.71973 32.5741 6.90592 33.1411 7.27832C33.7124 7.65072 33.998 8.23893 33.998 9.04297C33.998 9.58464 33.8584 10.0353 33.5791 10.395C33.2998 10.7547 32.8978 10.9811 32.373 11.0742V11.1377C33.0247 11.2604 33.5029 11.5037 33.8076 11.8677C34.1165 12.2274 34.271 12.7161 34.271 13.334C34.271 14.1676 33.979 14.8215 33.395 15.2954C32.8153 15.7651 32.007 16 30.9702 16H27.6187V6.71973ZM29.1357 10.5537H30.5957C31.2305 10.5537 31.6938 10.4543 31.9858 10.2554C32.2778 10.0522 32.4238 9.70947 32.4238 9.22705C32.4238 8.79118 32.2651 8.47591 31.9478 8.28125C31.6346 8.08659 31.1353 7.98926 30.4497 7.98926H29.1357V10.5537ZM29.1357 11.7852V14.7241H30.748C31.3828 14.7241 31.861 14.6035 32.1826 14.3623C32.5085 14.1169 32.6714 13.7318 32.6714 13.207C32.6714 12.7246 32.5063 12.367 32.1763 12.1343C31.8462 11.9015 31.3447 11.7852 30.6719 11.7852H29.1357ZM37.5337 11.7852H38.9556C39.9373 11.7852 40.6631 11.9544 41.1328 12.293C41.6025 12.6315 41.8374 13.1393 41.8374 13.8164C41.8374 14.54 41.592 15.0859 41.1011 15.4541C40.6144 15.818 39.8993 16 38.9556 16H36.042V8.97949H37.5337V11.7852ZM40.3584 13.8545C40.3584 13.5033 40.2272 13.2578 39.9648 13.1182C39.7067 12.9785 39.3343 12.9087 38.8477 12.9087H37.5337V14.8955H38.6572C39.2581 14.8955 39.6919 14.8109 39.9585 14.6416C40.2251 14.4723 40.3584 14.21 40.3584 13.8545ZM44.4399 16H42.9419V8.97949H44.4399V16ZM46.1729 11.7852C46.1729 10.2194 46.4373 9.01546 46.9663 8.17334C47.4995 7.33122 48.3459 6.78955 49.5054 6.54834C50.3813 6.37061 51.3906 6.1971 52.5332 6.02783L52.7427 7.3418C51.3547 7.55339 50.339 7.71842 49.6958 7.83691C49.0314 7.95964 48.5511 8.23258 48.2549 8.65576C47.9629 9.07894 47.7936 9.71582 47.7471 10.5664H47.8423C48.0835 10.2152 48.3988 9.94434 48.7881 9.75391C49.1774 9.55924 49.5942 9.46191 50.0386 9.46191C50.9019 9.46191 51.5747 9.73486 52.0571 10.2808C52.5396 10.8267 52.7808 11.5926 52.7808 12.5786C52.7808 13.7085 52.4867 14.5824 51.8984 15.2002C51.3145 15.818 50.5041 16.127 49.4673 16.127C48.439 16.127 47.6328 15.7461 47.0488 14.9844C46.4648 14.2227 46.1729 13.1562 46.1729 11.7852ZM49.5688 14.9082C50.6776 14.9082 51.2319 14.1803 51.2319 12.7246C51.2319 11.3197 50.7305 10.6172 49.7275 10.6172C49.4525 10.6172 49.1859 10.6764 48.9277 10.7949C48.6696 10.9134 48.4305 11.07 48.2104 11.2646C47.9946 11.4593 47.8275 11.6603 47.709 11.8677C47.709 12.8664 47.8677 13.6239 48.1851 14.1401C48.5024 14.6522 48.9637 14.9082 49.5688 14.9082ZM60.728 12.4771C60.728 13.6239 60.4339 14.5189 59.8457 15.1621C59.2575 15.8053 58.4386 16.127 57.3892 16.127C56.7332 16.127 56.1535 15.9788 55.6499 15.6826C55.1463 15.3864 54.7591 14.9611 54.4883 14.4067C54.2174 13.8524 54.082 13.2091 54.082 12.4771C54.082 11.3387 54.374 10.45 54.958 9.81104C55.542 9.17204 56.3651 8.85254 57.4272 8.85254C58.4429 8.85254 59.2469 9.1805 59.8394 9.83643C60.4318 10.4881 60.728 11.3683 60.728 12.4771ZM55.6182 12.4771C55.6182 14.0978 56.217 14.9082 57.4146 14.9082C58.5994 14.9082 59.1919 14.0978 59.1919 12.4771C59.1919 10.8732 58.5952 10.0713 57.4019 10.0713C56.7756 10.0713 56.3206 10.2786 56.0371 10.6934C55.7578 11.1081 55.6182 11.7026 55.6182 12.4771ZM66.0093 16.127C65.1206 16.127 64.4308 15.8075 63.9399 15.1685H63.8511C63.9103 15.7609 63.9399 16.1206 63.9399 16.2476V19.123H62.4482V8.97949H63.6543C63.6882 9.11068 63.758 9.42383 63.8638 9.91895H63.9399C64.4054 9.20801 65.1037 8.85254 66.0347 8.85254C66.9106 8.85254 67.592 9.16992 68.0786 9.80469C68.5695 10.4395 68.8149 11.3302 68.8149 12.4771C68.8149 13.6239 68.5653 14.5189 68.0659 15.1621C67.5708 15.8053 66.8853 16.127 66.0093 16.127ZM65.6475 10.0713C65.055 10.0713 64.6213 10.2448 64.3462 10.5918C64.0754 10.9388 63.9399 11.4932 63.9399 12.2549V12.4771C63.9399 13.3319 64.0754 13.9518 64.3462 14.3369C64.617 14.7178 65.0592 14.9082 65.6729 14.9082C66.1891 14.9082 66.5869 14.6966 66.8662 14.2734C67.1455 13.8503 67.2852 13.2472 67.2852 12.4644C67.2852 11.6772 67.1455 11.0827 66.8662 10.6807C66.5911 10.2744 66.1849 10.0713 65.6475 10.0713ZM80.063 8.97949V16H78.5649V10.1602H75.4165V16H73.9248V8.97949H80.063ZM86.5947 16L86.2964 15.0225H86.2456C85.9071 15.4499 85.5664 15.7419 85.2236 15.8984C84.8809 16.0508 84.4408 16.127 83.9033 16.127C83.2135 16.127 82.674 15.9408 82.2847 15.5684C81.8996 15.196 81.707 14.6691 81.707 13.9878C81.707 13.2642 81.9757 12.7183 82.5132 12.3501C83.0506 11.9819 83.8695 11.7809 84.9697 11.7471L86.1821 11.709V11.3345C86.1821 10.8859 86.0763 10.5516 85.8647 10.3315C85.6574 10.1073 85.3337 9.99512 84.8936 9.99512C84.5339 9.99512 84.189 10.048 83.8589 10.1538C83.5288 10.2596 83.2114 10.3844 82.9067 10.5283L82.4243 9.46191C82.8052 9.26302 83.222 9.11279 83.6748 9.01123C84.1276 8.90544 84.555 8.85254 84.957 8.85254C85.8499 8.85254 86.5228 9.0472 86.9756 9.43652C87.4326 9.82585 87.6611 10.4373 87.6611 11.271V16H86.5947ZM84.373 14.9844C84.9147 14.9844 85.3485 14.8341 85.6743 14.5337C86.0044 14.229 86.1694 13.8037 86.1694 13.2578V12.6484L85.2681 12.6865C84.5656 12.7119 84.0535 12.8304 83.7319 13.042C83.4146 13.2493 83.2559 13.5688 83.2559 14.0005C83.2559 14.3136 83.349 14.557 83.5352 14.7305C83.7214 14.8997 84.0007 14.9844 84.373 14.9844ZM95.9956 14.8447H97.0112V18.4692H95.6084V16H89.7432V8.97949H91.2349V14.8193H94.5039V8.97949H95.9956V14.8447ZM99.7153 8.97949V12.5786C99.7153 12.9976 99.6815 13.6133 99.6138 14.4258L103.137 8.97949H104.958V16H103.524V12.4644C103.524 12.2697 103.535 11.9544 103.556 11.5186C103.581 11.0827 103.602 10.7653 103.619 10.5664L100.109 16H98.2871V8.97949H99.7153ZM110.151 16.127C109.059 16.127 108.204 15.8096 107.586 15.1748C106.973 14.5358 106.666 13.6577 106.666 12.5405C106.666 11.3937 106.952 10.4924 107.523 9.83643C108.094 9.1805 108.879 8.85254 109.878 8.85254C110.805 8.85254 111.537 9.13395 112.074 9.69678C112.612 10.2596 112.88 11.034 112.88 12.02V12.8262H108.202C108.223 13.5075 108.407 14.0322 108.754 14.4004C109.101 14.7643 109.59 14.9463 110.221 14.9463C110.635 14.9463 111.021 14.9082 111.376 14.832C111.736 14.7516 112.121 14.6204 112.531 14.4385V15.6509C112.167 15.8244 111.799 15.9471 111.427 16.019C111.054 16.091 110.629 16.127 110.151 16.127ZM109.878 9.98242C109.404 9.98242 109.023 10.1326 108.735 10.4331C108.452 10.7336 108.283 11.1715 108.228 11.7471H111.414C111.406 11.1673 111.266 10.7293 110.995 10.4331C110.724 10.1326 110.352 9.98242 109.878 9.98242ZM116.067 8.97949V11.7979H119.374V8.97949H120.866V16H119.374V12.9722H116.067V16H114.575V8.97949H116.067ZM128.28 8.97949V10.1475H125.995V16H124.497V10.1475H122.211V8.97949H128.28ZM135.859 12.4771C135.859 13.6239 135.565 14.5189 134.977 15.1621C134.388 15.8053 133.569 16.127 132.52 16.127C131.864 16.127 131.284 15.9788 130.781 15.6826C130.277 15.3864 129.89 14.9611 129.619 14.4067C129.348 13.8524 129.213 13.2091 129.213 12.4771C129.213 11.3387 129.505 10.45 130.089 9.81104C130.673 9.17204 131.496 8.85254 132.558 8.85254C133.574 8.85254 134.378 9.1805 134.97 9.83643C135.563 10.4881 135.859 11.3683 135.859 12.4771ZM130.749 12.4771C130.749 14.0978 131.348 14.9082 132.545 14.9082C133.73 14.9082 134.323 14.0978 134.323 12.4771C134.323 10.8732 133.726 10.0713 132.533 10.0713C131.906 10.0713 131.451 10.2786 131.168 10.6934C130.889 11.1081 130.749 11.7026 130.749 12.4771ZM143.673 10.7759C143.673 11.6053 143.188 12.1068 142.219 12.2803V12.3311C142.761 12.3945 143.176 12.5659 143.463 12.8452C143.751 13.1245 143.895 13.4863 143.895 13.9307C143.895 14.5951 143.641 15.1071 143.133 15.4668C142.63 15.8223 141.896 16 140.931 16H137.579V8.97949H140.918C142.755 8.97949 143.673 9.57829 143.673 10.7759ZM142.365 13.8418C142.365 13.5033 142.234 13.2642 141.972 13.1245C141.709 12.9806 141.316 12.9087 140.791 12.9087H139.071V14.8955H140.829C141.853 14.8955 142.365 14.5443 142.365 13.8418ZM142.181 10.9028C142.181 10.6235 142.071 10.4225 141.851 10.2998C141.635 10.1729 141.312 10.1094 140.88 10.1094H139.071V11.7979H140.658C141.157 11.7979 141.536 11.7344 141.794 11.6074C142.052 11.4762 142.181 11.2414 142.181 10.9028Z" fill="white"/>
                                            <defs>
                                                <linearGradient id="icn-crown-wide-gradient" x1="0.393555" y1="0" x2="150.136" y2="24.5682" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#574FB8"/>
                                                    <stop offset="1" stop-color="#2C2B67"/>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class="clinic_reviews__rating">
                                        <RatingStars class="clinic-topping__docstatus doc-status"
                                                     :rating="clinic.rating"
                                                     :ratingCount="clinic.totalReviews"
                                        />
                                    </div>
                                    <div class="clinic_reviews__count">
                                        <template v-if="clinic.totalReviews">
                                            {{ plural(clinic.totalReviews, 'Оставьте отзыв', 'отзыв', 'отзыва', 'отзывов') }}
                                        </template>
                                        <template v-else>
                                            Оставьте отзыв
                                        </template>
                                    </div>
                                </div>

                                <div class="clinic_info__title">{{clinic.name}}</div>
                                <div class="clinic_info__time">{{ scheduleToday(clinic.scheduleInfo) }}</div>
                                <div class="clinic_info__gal" v-if="clinic.photos.length">
                                    <div
                                        v-for="(photo, index) in clinic.photos.slice(0, 3)" :key="photo"
                                        class="clinic-teaser-tumbs__img">

                                        <img :alt="'Фото '+ clinic.name"
                                             :src="storagePublicUrl + '/images/clinicPhotos/120x120/' + photo"
                                             loading="lazy"
                                             height="60">
                                    </div>
                                </div>
                                <div class="clinic_info__address">
                                    {{ clinic.address }}
                                </div>
                                <div class="clinic_info__metro">
                                    <div v-for="(metro) in clinic.metroList ?? []" class="clinic_info__metro_item">
                                        <i v-for="color in metro.colors" :style="{background: color}"/>
                                        {{ metro.name + ' (' + metro.distance + ')' }}
                                    </div>
                                </div>
                                <div class="clinic_info__actions">
                                    <div v-if="clinic.formattedPhone" class="btn btn-green clinic-topping__actions_phone">
                                        <div v-if="clinic.formattedPhone && phoneShowed" class="btn btn-green">
                                            <meta itemprop="telephone" :content="clinic.formattedPhone"/>
                                            <a itemprop="telephone" :href="'tel:' + (clinic.formattedPhone).replace(/[ ()-]/g,'')">
                                                {{clinic.formattedPhone}}
                                            </a>
                                        </div>
                                        <div  v-else-if="clinic.formattedPhone" @click.prevent="showPhone" class="btn btn-green">
                                            <meta itemprop="telephone" :content="clinic.formattedPhone"/>
                                            {{clinic.formattedPhone.slice(0,12)}}- ... показать
                                        </div>
                                    </div>

                                    <a v-if="M.actionButtonOn && M.actionButtonName" class="btn btn-white clinic-topping__actions_site" href="#" rel="nofollow">
                                        {{M.actionButtonName}}
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>

        </ValidationObserver>
    </main>
</template>
<script>
import { plural } from "@/global/helpers";
import RatingStars from "@/components/base/RatingStars";

export default {
    components: {RatingStars},
    props:{
        clinicId: {
            type: String,
            required: true,
        },
        clinics: {
            type: Array,
            required: true,
        },
        storagePublicUrl: {
            type: String,
            required: true
        },
    },
    data(){
        return{
            selectedClinicId: this.clinicId,
            M:{
                clinicId: null,
                actionButtonOn: null,
                actionButtonName: null,
                actionButtonHref: null,
            },
            clinic:{
                id: null,
                name: null,
                img: null,
                url: null,
                hasUsers: null,
                localityOrCity: null,
                totalReviews: null,
                photos: null,
                rating: null,
                address: null,
                metroList: null,
                formattedPhone: null,
            },
            phoneShowed:false,
            siteUrl: 'https://doctu.ru',
            plural: plural,
            Mhashcode: null,
        }
    },
    mounted: function () {
        this.refresh();
    },
    methods:{
        onUpdate(btn){
            if(!this.needSave){
                return;
            }
            this.$refs.actionForm.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }
                btn.startLoadingAnimation();

                this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
            });
        },
        update(){
            let clinic = this.clinics.filter((el)=> el.id === this.selectedClinicId)[0]
            clinic.actionButtonOn = this.M.actionButtonOn
            clinic.actionButtonName = this.M.actionButtonName
            clinic.actionButtonHref = this.M.actionButtonHref

            return this.axios.post('actions/update', this.M).then(() => {
                this.Mhashcode = JSON.stringify(this.M).hashCode();
                this.$modal('Данные сохранены',{
                    name: 'ОК',
                    callback: () => {
                        this.closeModal();
                    },
                },{}, false, 'only-text-dialog')
            }).catch((res) => {
                if (res.errors && res.errors.common) {
                    this.$modal(res.errors.common[0],{
                        name: 'ОК',
                        callback: () => {
                            this.closeModal();
                        },
                    },{}, false, 'only-text-dialog')
                }
            });
        },
        refresh(){
            setTimeout( ()=> {
                let clinic = this.clinics.find((el) => el.id === this.selectedClinicId)
                if (!clinic) {
                    return;
                }
                this.M.clinicId = clinic.id
                this.M.actionButtonOn = clinic.actionButtonOn
                this.M.actionButtonName = clinic.actionButtonName
                this.M.actionButtonHref = clinic.actionButtonHref
                this.Mhashcode = null

                this.clinic = clinic
            }, 10)
            setTimeout(() => {
                this.Mhashcode = JSON.stringify(this.M).hashCode();
            }, 500)
        },
        showPhone(){
            this.phoneShowed = true
        },
        scheduleToday(schedule){
            let date = new Date();
            let days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
            let scheduleToday = schedule[days[date.getDay()]];

            if (!scheduleToday) {
                return 'Сегодня выходной';
            }

            if (scheduleToday === 'full') {
                return 'Сегодня круглосуточно';
            }

            let hours = date.getHours();
            if (hours < 10) {
                hours = '0' + hours;
            }

            let minutes = date.getMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            let time = hours + ':' + minutes;

            if (scheduleToday[0] > time) {
                return 'Сегодня с ' + scheduleToday[0];
            }

            return 'Сегодня до ' + scheduleToday[1];
        }
    },
    watch:{
        needSave(val, oldVal) {
            if (val) {
                window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
            } else {
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
            }

        },
    },
    computed:{
        needSave: function () {
            return this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.M).hashCode());
        },
    }
}

</script>
<style lang="scss">
#actionBtnForm {

    .clinic { font-size: 14px; width: 100%; max-width: 62em; border: 1px solid #DDD9EA; border-radius: .285em; padding: 1.142em; display: flex; gap: 1.714em; align-items: flex-start; font-family: 'Open Sans', sans-serif; }
    .clinic_profile { flex: 0 0 8.785em; display: flex; flex-direction: column; gap: .571em; align-items: center; }
    .clinic_profile__img { box-sizing: border-box; aspect-ratio: 1/1; border-radius: .285em; border: 1px solid #DDD9EA; display: flex; align-items: center; justify-content: center; }
    .clinic_profile__img img { display: block; max-width: 80%; max-height: 80%; }
    .clinic_profile__link { color: #9896AE; line-height: 1; text-decoration: underline; }


    .clinic_reviews { float: right; margin-left: 1.714em; text-align: right; }
    .clinic_reviews__label svg { width: 10.714em; height: 1.642em; display: block; margin-left: auto; }
    .clinic_reviews__rating { margin-top: .444em; color: #13A546; font-size: 1.285em; line-height: 1; font-weight: 600; display: flex; align-items: center; justify-content: flex-end; gap: 2px; margin-left: auto; }
    .clinic_reviews__rating svg { width: 1.285em; height: 1.285em; color: #F2C94C; }
    .clinic_reviews__rating .star-rating .fa { width: 1.285em; height: 1.285em;  background-size: contain !important;}
    .clinic_reviews__rating span { margin-left: .142em; }
    .clinic_reviews__count { margin-top: .571em; color: #9896AE; text-decoration: underline; line-height: 1.2; }

    .clinic_reviews {
        & .clinic_reviews__rating .rating{font-size: 1.285em;}
        .clinic_reviews__rating .star-rating .fa-star {
            background: url(https://doctu.ru/img/icons/clarity_star-solid.svg) 50% no-repeat
        }

        .clinic_reviews__rating .star-rating .fa-star-half-o {
            background: url(https://doctu.ru/img/icons/clarity_half-star-solid.svg) 50% no-repeat
        }

        .clinic_reviews__rating .star-rating .fa-star-o {
            background: url(https://doctu.ru/img/icons/clarity_star-solid-empty.svg) 50% no-repeat
        }

    }

    .clinic_info { flex: 1 1 auto; }
    .clinic_info__title { font-size: 1.45em; line-height: 1.2; font-weight: 600; text-box-trim: trim-both; }
    .clinic_info__price { margin-top: 1.142em; color: #13A546; line-height: 1.2; font-weight: 600; }
    .clinic_info__time { margin-top: .285em; color: #9896AE; line-height: 1.2; font-weight: 600; }
    .clinic_info__gal { margin-top: 1.142em; display: flex; gap: .571em; flex-wrap: wrap; }
    .clinic_info__gal img { display: block; line-height: 1; width: 4.428em; aspect-ratio: 1/1; border-radius: .285em; }
    .clinic_info__address { margin-top: 1.142em; color: #2C2B67; line-height: 1.2; font-weight: 600; border-bottom: 1px dashed currentColor; display: inline-block; }
    .clinic_info__metro { display: flex; flex-wrap: wrap; gap: .285em 1.142em; margin-top: .571em; }
    .clinic_info__metro_item { display: flex; gap: .571em; line-height: 1.2; align-items: center; }
    .clinic_info__metro_item i { display: block; width: .5em; height: .5em; border-radius: .5em; border: 1px solid #fff; margin-left: -1px; }
    .clinic_info__metro_item i + i { margin-left: -.714em; }
    .clinic_info__metro_item i.blue { background-color: #2F80ED; }
    .clinic_info__metro_item i.orange { background-color: #F17F30; }
    .clinic_info__metro_item i.red { background-color: #DE2944; }
    .clinic_info__metro_item i.purple { background-color: #8C469A; }
    .clinic_info__actions { display: flex; gap: 1.142em; margin-top: 1.142em; }
    .clinic .btn { font-size: 1em; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; width: 15.428em; padding: 0; box-sizing: border-box; border-radius: .285em; height: 2.714em; background-color: #13A546; color: #fff; border: 0 none; font-weight: 600; line-height: 1; font-family: "Open Sans", sans-serif; }
    .clinic .btn.btn-white { background-color: #fff; color: #2C2B67; border: 1px solid #DDD9EA; }

    .promo img{
        width: auto;
    }

    ul,
    ol {
        padding: 0 0 0 0px;
    }

    .promo {
        color: #272727;
        padding: 50px 70px;
        display: flex;
        flex-wrap: wrap;
        gap: 32px;
        row-gap: 16px;
        align-items: normal;
        font-family: "Open Sans", sans-serif;
        font-size: 20px;
        line-height: 30px;
    }

    .promo__clinic {
        flex: 1 1 auto;
    }

    .promo__clinic-title {
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 14px;
        line-height: 120%;
        color: #000;
    }

    .promo__data {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 500px;
    }

    .promo__title {
        color: #272727;
        font-size: 40px;
        line-height: 50px;
        font-weight: bold;
        flex: 0 0 100%;
    }

    .promo__title label { display: inline-flex; vertical-align: baseline; margin-right: 16px; }
    .promo__title input[type=checkbox] { display: none; }
    .promo__title input[type=checkbox] + span { position: relative; top: 0; }
    .promo__title input[type=checkbox] + span { position: relative; }
    .promo__title input[type=checkbox] + span:before { width: 50px; height: 31px; border-radius: 31px; background-color: #bdbdbd; display: block; content: ''; position: relative; }
    .promo__title input[type=checkbox] + span:after { width: 22px; height: 22px; border-radius: 22px; background-color: #fff; display: block; content: ''; left: 4px; top: 4px; position: absolute; z-index: 1; transition: all .2s ease; will-change: transform; }
    .promo__title input[type=checkbox]:checked + span:before { background-color: #13A546; }
    .promo__title input[type=checkbox]:checked + span:after { transform: translateX(19px); }

    .promo__text {
        max-width: 580px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .promo__form {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .promo ul {
        display: flex;
        flex-direction: column;
        gap: 0px;
    }

    .promo ul li{
        padding-left: 0;

        & .multiselect__element{
            min-height: 32px;
        }
    }
    .promo ul li::before{
        background: transparent;
    }

    .promo ol {
        padding-left: 25px;
        list-style-type: none;
        counter-reset: num;
    }

    .promo ol li {
        position: relative;
        padding-left: 0;
    }

    .promo ol li::before {
        color: #13A546;
        font-size: 20px;
        font-weight: 600;
        content: counter(num) '.';
        counter-increment: num;
        display: inline-block;
        position: absolute;
        top: 0px;
        left: -26px;
        background: transparent;
    }

    .promo__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 50px;
        row-gap: 25px;
        align-items: center;
        margin-top: 24px;
    }

    .promo__btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #13a546;
        color: #fff;
        text-decoration: none;
        height: 54px;
        border-radius: 5px;
        padding: 10px 50px 14px;
        transition: 0.5s ease;
        width: 254px;
    }

    .promo__btn.disabled,
    .promo__btn[disabled] {
        background-color: #bdbdbd;
    }

    .promo__btn:hover {
        background-color: #0a8036;
        color: #fff;
    }

    .promo__link {
        color: #2c2b67;
        text-decoration: none;
        font-weight: 600;
        border-bottom: 2px dotted #2c2b67;
        line-height: 30px;
        transition: 0.5s ease;
    }

    .promo__link:hover {
        color: #13a546;
        border-bottom: 2px dotted #13a546;
    }

    .promo__akcent-label {
        color: #13a546;
        font-weight: 600;
    }

    .promo__markers {
        grid-area: markers;
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .promo__marker {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 14px 8px;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 600;
        line-height: 120%;
    }

    .promo__marker_red {
        background: #FFE0E0;
        color: #EB5757;
    }

    .promo__marker_green {
        background: #F2FDF1;
        color: #13A546;
    }

    .clinic-topping {
        border: 1px solid #DDD9EA;
        border-radius: 4px;
        padding: 16px;
    }

    //.clinic-topping img {
    //    display: block;
    //}

    .field-text.disabled input {
        pointer-events: none;
        background-color: #f7f7fa;
    }

    .field-text label {
        display: block;
        font-weight: 600;
        margin-bottom: 8px !important;
        font-size: 14px;
        line-height: 120%;
        color: #000;
    }

    .field-text__wrap {
        position: relative;
    }

    .field-text__wrap_clear {
        cursor: pointer;
        position: absolute;
        right: 11px;
        top: 3px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .field-text__wrap_calendar {
        cursor: pointer;
        position: absolute;
        right: 11px;
        top: 12px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .field-text__wrap_search {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        display: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .field-text__wrap input {
        padding-right: 30px !important;
        height: 38px;
        background: #FFFFFF;
        border: 1px solid #DDD9EA !important;
        border-radius: 4px;
        padding: 10px 32px 11px 10px;
        color: #000;
        font-size: 14px;
        line-height: 120%;
        width: 100%;
        background-clip: padding-box;
    }

    .field-text__wrap input::placeholder {
        color: #9896AE;
    }

    .field-text__wrap input:placeholder-shown + .field-text__wrap_clear {
        display: none;
    }

    .field-text__wrap input:placeholder-shown + .field-text__wrap_clear + .field-text__wrap_search {
        display: block;
    }

    .field-text__wrap input:disabled {
        color: #9896AE;
        background: #F7F7FA;
    }

    .field-text__wrap input:disabled + .field-text__wrap_clear {
        display: none;
    }

    .field-text__wrap_desc {
        font-size: 12px;
        line-height: 120%;
        color: #9896AE;
        margin-top: 8px;
    }

    .field-text.error .field-text__wrap input {
        border: 2px solid #EB5757;
    }

    .field-text.error .field-text__wrap_desc {
        display: none;
    }

    .field-text.error .error {
        margin-top: 8px;
        line-height: 120%;
        font-size: 12px;
        color: #EB5757;
    }

    @media (max-width: 767px) {
        .field-text.error .field-text__wrap input {
            border: 2px solid #EB5757;
        }
    }

    .field-select {
        font-size: 14px;
        line-height: 120%;
    }

    .field-select.disabled .field-select__wrap {
        pointer-events: none;
        background-color: #f7f7fa;
    }

    .field-select label {
        display: block;
        font-weight: 600;
        margin-bottom: 8px !important;
        font-size: 14px;
        line-height: 120%;
        color: #000;
    }

    .field-select__wrap {
        position: relative;
        display: flex;
        gap: 4px;
        align-items: center;
        background: #FFFFFF;
        border-radius: 4px;
        min-height: 38px;
        height: 38px;
    }

    .field-select__wrap_list {
        display: none;
        position: absolute;
        z-index: 1;
        left: -1px;
        top: calc(100% - 1px);
        max-width: calc(100% + 2px);
        width: calc(100% + 2px);
        background: #fff;
        border: 1px solid #DDD9EA;
        padding: 5px 9px;
        flex-direction: column;
        max-height: 150px;
        overflow-y: auto;
    }

    .field-select__wrap_list .item, .multiselect__element {
        padding: 8px 0;
        cursor: pointer;
        //display: flex;
        //align-items: center;
        gap: 12px;
        line-height: 120%;
        font-size: 14px;
        min-height: unset !important;
        display: inline-block;
        width: 100%;

        &:hover {
            .textarea {
                color: #272727 !important;
            }
        }

        .textarea:hover {
            background-color: transparent !important;
        }
    }

    .field-select__wrap_list .item__marker {
        height: 8px;
        width: 8px;
        border-radius: 50%;
        overflow: hidden;
    }

    .field-select.open .field-select__wrap_list {
        display: flex;
    }

    .field-select.selected .field-select__wrap_placeholder,
    .field-select.selected .field-select__wrap_chevron {
        display: none;
    }

    .field-select.selected .field-select__wrap_value {
        display: flex;
    }

    .field-select.selected .field-select__wrap_clear {
        display: block;
    }

    .field-select.selected-always .field-select__wrap_value {
        display: flex;
    }

    .multiselect.multiselect--disabled {
        .multiselect__tags {
            background-color: #f7f7fa;
            .multiselect__single {
                background-color: #f7f7fa;
                color: #9896AE !important;
            }
        }
    }

    ul.multiselect__content {
        padding: 5px 9px;
    }

    .multiselect__option {
        min-height: unset !important;
        background: none !important;
        color: #272727 !important;
    }

    .multiselect.multiselect--active .multiselect__tags {
        border-color: #DDD9EA !important;
    }

    .multiselect__single {
        color: #272727 !important;
    }

    @media (max-width: 767px) {
        .field-select__wrap_chevron.in-popup {
            transform: rotate(0deg);
        }
    }


    @media (max-width: 991px) {
        .promo {
            flex-wrap: wrap;
        }
    }

    @media (max-width: 600px) {
        .promo {
            padding: 30px 30px;
            font-size: 20px;
            line-height: 25px;
        }

        .promo__title {
            font-size: 33px;
        }

        .promo li {
            padding-left: 20px;
        }

        .promo li::before {
            top: 10px;
            height: 8px;
            width: 8px;
        }
    }

    @media (max-width: 1586px) {
        .clinic { font-size: calc((100vw - 900px) / 67); }
    }
}
</style>

